import logo from './logo.svg';
import './App.css';
import { BrowserRouter ,Routes , Route } from 'react-router-dom';
import Home from './Views/Home';
import About from './Views/About';
import Terms from './Views/Terms';
import Privacy from './Views/Privacy';
import Header from './Components/Header';
import Footer from './Components/Footer';
import './scss/custom.scss'


function App() {
  return (
    <div className="App">
      {/* <!-- preloder --> */}
      <div className="loading_screen ">
        <div className="loader_body">
          <div className="birds_wrap">
            <figure><img src="images/bird1.svg" alt="" className="contain" /></figure>
            <figure><img src="images/bird2.svg" alt="" className="contain" /></figure>
          </div>
        </div>
      </div>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path='/' element={<Home />}></Route>
        </Routes>
        <Routes>
          <Route path="about" element={<About />} />
        </Routes>
        <Routes>
          <Route path="privacy" element={<Privacy />}></Route>
        </Routes>
        <Routes>
          <Route path="terms" element={<Terms />}></Route>
        </Routes>
        <Footer />
      </BrowserRouter>

    </div>
  );
}

export default App;
